import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ReglageOscilloBattant from "../pages/reglage-fenetre-oscillo-battant/page";
import FenetreOscilloBloquee from "../pages/fenetre-oscillo-battant-bloquee/page";
import PoigneeFenetreBloquee from "../pages/poignee-fenetre-bloquee/page";
import CremoneFenetre from "../pages/cremone-fenetre/page";
import GondPaumelleFenetre from "../pages/gond-paumelle-fenetre/page";
import FenetreFermeMal from "../pages/fenetre-ferme-mal/page";
import FenetrePVC from "../pages/fenetre-pvc/page";
import FenetreBois from "../pages/fenetre-bois/page";
import FenetreAlu from "../pages/fenetre-alu/page";
import ReparationFenetreHaguenau from "../pages/reparation-fenetre-haguenau/page";
import ReparationFenetreIllkirch from "../pages/reparation-fenetre-illkirch-graffenstaden/page";
import ReparationFenetreBischheim from "../pages/reparation-fenetre-bischheim/page";
import ReparationFenetreBischwiller from "../pages/reparation-fenetre-bischwiller/page";
import ReparationFenetreObernai from "../pages/reparation-fenetre-obernai/page";
import ReparationFenetreHoenheim from "../pages/reparation-fenetre-hoenheim/page";
import QuiSommesNous from "../pages/qui-sommes-nous/page";
import Tarifs from "../pages/tarifs/page";
import PolitiqueConfidentialite from "../pages/politique-confidentialite/page";
import NosPrestations from "../pages/nos-prestations/page";
import ReparationFenetreSchiltigheim from "../pages/reparation-fenetre-schiltigheim/page";
import ReparationFenetreSelestat from "../pages/reparation-fenetre-selestat/page";
import ReparationFenetreLingolsheim from "../pages/reparation-fenetre-lingolsheim/page";
import ReparationFenetreSaverne from "../pages/reparation-fenetre-saverne/page";
import ReparationFenetreOstwald from "../pages/reparation-fenetre-ostwald/page";
import ReparationFenetreErstein from "../pages/reparation-fenetre-erstein/page";
import ZonesInterventions from "../pages/zones-dinterventions/page";
import Avis from "../pages/avis/page";
import MentionsLegales from "../pages/mentions-legales/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/reglage-fenetre-oscillo-battant",
    element: <ReglageOscilloBattant />,
  },
  {
    path: "/fenetre-oscillo-battant-bloquee",
    element: <FenetreOscilloBloquee />,
  },
  {
    path: "/poignee-fenetre-bloquee",
    element: <PoigneeFenetreBloquee />,
  },
  {
    path: "/cremone-fenetre",
    element: <CremoneFenetre />,
  },
  {
    path: "/gond-paumelle-fenetre",
    element: <GondPaumelleFenetre />,
  },
  {
    path: "/fenetre-ferme-mal",
    element: <FenetreFermeMal />,
  },
  {
    path: "/fenetre-pvc",
    element: <FenetrePVC />,
  },
  {
    path: "/fenetre-bois",
    element: <FenetreBois />,
  },
  {
    path: "/fenetre-alu",
    element: <FenetreAlu />,
  },
  {
    path: "/reparation-fenetre-haguenau",
    element: <ReparationFenetreHaguenau />,
  },
  {
    path: "/reparation-fenetre-illkirch-graffenstaden",
    element: <ReparationFenetreIllkirch />,
  },
  {
    path: "/reparation-fenetre-bischheim",
    element: <ReparationFenetreBischheim />,
  },
  {
    path: "/reparation-fenetre-bischwiller",
    element: <ReparationFenetreBischwiller />,
  },
  {
    path: "/reparation-fenetre-obernai",
    element: <ReparationFenetreObernai />,
  },
  {
    path: "/reparation-fenetre-hoenheim",
    element: <ReparationFenetreHoenheim />,
  },
  {
    path: "/reparation-fenetre-schiltigheim",
    element: <ReparationFenetreSchiltigheim />,
  },
  {
    path: "/reparation-fenetre-selestat",
    element: <ReparationFenetreSelestat />,
  },
  {
    path: "/reparation-fenetre-lingolsheim",
    element: <ReparationFenetreLingolsheim />,
  },
  {
    path: "/reparation-fenetre-saverne",
    element: <ReparationFenetreSaverne />,
  },
  {
    path: "/reparation-fenetre-ostwald",
    element: <ReparationFenetreOstwald />,
  },
  {
    path: "/reparation-fenetre-erstein",
    element: <ReparationFenetreErstein />,
  },
  {
    path: "/zones-dinterventions",
    element: <ZonesInterventions />,
  },
  {
    path: "/qui-sommes-nous",
    element: <QuiSommesNous />,
  },
  {
    path: "/tarifs",
    element: <Tarifs />,
  },
  {
    path: "/politique-confidentialite",
    element: <PolitiqueConfidentialite />,
  },
  {
    path: "/nos-prestations",
    element: <NosPrestations />,
  },
  {
    path: "/avis",
    element: <Avis />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegales />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;